module.exports = __webpack_public_path__ + "img/fund_img1.27e18ac6.png";